import { Theme } from '@mui/material';

export const createMobileLocationCardStyles = (isHorizontalScrolling: boolean, isLocationCardsInHeader: boolean) => ({
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
	overflow: 'scroll',
	...(!isHorizontalScrolling && !isLocationCardsInHeader && { height: '34rem' }),
});

export const mobileLocationCardsContainer = (isHorizontalScrolling: boolean) => ({
	flexWrap: 'inherit',
	overflowX: 'auto',
	display: 'flex',
	width: '100vw',
	marginTop: '1.25rem',
	...(isHorizontalScrolling && { paddingX: '.5rem' }),
});

export const getMapContainerStyles = (theme: Theme) => ({
	border: '0.0625rem solid',
	borderLeft: 'none',
	borderColor: 'neutrals.primary',
	[theme.breakpoints.down('md')]: {
		border: 'none',
	},
});

export const getLocationsCardContainerStyles = (
	theme: Theme,
	fullWidth?: boolean,
	isLocationCardsInHeader?: boolean,
	isSkeleton?: boolean
) => ({
	display: 'flex',
	flexDirection: 'column',
	flexWrap: 'nowrap',
	borderBottom: '0.0625rem solid',
	borderLeft: '0.0625rem solid',
	borderTop: '0.0625rem solid',
	borderRadius: fullWidth ? '0' : '0.5rem 0rem 0rem 0.5rem',
	borderColor: 'neutrals.primary',
	backgroundColor: isLocationCardsInHeader ? theme.palette.backgrounds?.white : theme.palette.backgrounds?.light,
	...(isLocationCardsInHeader && !isSkeleton && { position: { xs: 'none', md: ' absolute' } }),
	overflow: 'scroll',
	paddingBottom: '1rem',
	px: '',
	'::-webkit-scrollbar': {
		display: 'none',
	},
	msOverflowStyle: 'none',
	scrollBarWidth: 'none',
	height: '100%',
	[theme.breakpoints.down('md')]: {
		borderRadius: '0.5rem',
		backgroundColor: `${theme.palette.backgrounds?.white}`,
		px: '1rem',
	},
});

export const noResultsFoundMessageStyles = {
	display: 'flex',
	flexWrap: 'nowrap',
	justifyContent: 'center',
	alignItems: 'center',
	width: 'auto',
	height: 'fit-content',
	border: '1px solid',
	borderRadius: '.25rem',
	borderColor: 'info.dark',
	backgroundColor: 'info.light',
	padding: '1rem',
	gap: '.5rem',
	marginX: '1.25rem',
	marginY: { xs: '1.25rem', md: '0' },
	'&.MuiGrid-root': {
		flexBasis: 'auto',
	},
};

export const noResultsFoundIconStyles = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};
